/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Listen_On_Go_TitleInputs */

const en_features_listen_on_go_title = /** @type {(inputs: Features_Listen_On_Go_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen to physical books on the go!`)
};

const es_features_listen_on_go_title = /** @type {(inputs: Features_Listen_On_Go_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Escucha libros físicos donde quieras!`)
};

/**
* | output |
* | --- |
* | "Listen to physical books on the go!" |
*
* @param {Features_Listen_On_Go_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const features_listen_on_go_title = /** @type {((inputs?: Features_Listen_On_Go_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Listen_On_Go_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_features_listen_on_go_title(inputs)
	return en_features_listen_on_go_title(inputs)
});